

export class RichTextMarkupError extends Error {
  constructor(message) {
    super(message)
    this.name = 'RichTextMarkupError'
  }
}

export class DuplicateElementTypeError extends RichTextMarkupError {
  constructor(elementType) {
    super(`Duplicate element type defined in parser "${elementType}"`)
    this.name = 'DuplicateElementTypeError'
  }
}

export class DuplicatePatternError extends RichTextMarkupError {
  constructor(pattern) {
    super(`Duplicate pattern defined in parser "${pattern}"`)
    this.name = 'DuplicatePatternError'
  }
}

export class DuplicateParserConfigVersionError extends RichTextMarkupError {
  constructor(version) {
    super(`Duplicate parser config version defined "${version}"`)
    this.name = 'DuplicateParserConfigVersionError'
  }
}

export class EmptyClosingPatternError extends RichTextMarkupError {
  constructor() {
    super('Empty closing patterns are not allowed')
    this.name = 'EmptyClosingPatternError'
  }
}

export class IdenticalOpenClosingPatternError extends RichTextMarkupError {
  constructor(pattern) {
    super(`"${pattern}" defined as the open and closing pattern for a sequence`)
    this.name = 'IdenticalOpenClosingPatternError'
  }
}

export class PatternTooLongError extends RichTextMarkupError {
  constructor(pattern, maxLength) {
    super(`Pattern "${pattern}" longer than max length of ${maxLength}`)
    this.name = 'PatternTooLongError'
  }
}

export class ParserConfigNotFoundError extends RichTextMarkupError {
  constructor(version) {
    super(`No parser config with version "${version}" specified`)
    this.name = 'ParserConfigNotFoundError'
  }
}

export class ParserConfigVersionNotANumberError extends RichTextMarkupError {
  constructor(version) {
    super(`Duplicate parser config version "${version}" is not a number`)
    this.name = 'ParserConfigVersionNotANumberError'
  }
}

export class UnableToRepresentAsMarkupError extends RichTextMarkupError {
  constructor(reason) {
    super(`Unable to represent as markup. Reason: ${reason}`)
    this.name = 'UnableToRepresentAsMarkupError'
  }
}

export class UnsupportedElementTypeError extends RichTextMarkupError {
  constructor(elementType) {
    super(`Unsupported element type "${elementType}"`)
    this.name = 'UnsupportedElementTypeError'
  }
}

export class UnsupportedNodeClassError extends RichTextMarkupError {
  constructor(nodeClass) {
    super(`Unsupported node class "${nodeClass}"`)
    this.name = 'UnsupportedNodeClassError'
  }
}

export class WhitespacePatternError extends RichTextMarkupError {
  constructor() {
    super('Whitespace patterns are not allowed')
    this.name = 'WhitespacePatternError'
  }
}